import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})

export class MessageService {
  
  constructor(private snackBar: MatSnackBar) { }

  alert(msg: string) {
    this.snackBar.open(msg, '', {
      duration: 5000,
    });
  }
}
